import React from 'react';
import { BriefcaseIcon, RepeatIcon, SparklesIcon, TargetIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { differences } from '../../data/content';
const icons = [SparklesIcon, BriefcaseIcon, TargetIcon, RepeatIcon];
export function DifferenceSection() {
  return <section id="different" className="bg-white px-5 py-14 sm:py-20" data-id="element-40" data-mp="2fbpof17b7puk">
      <div className="mx-auto max-w-6xl" data-id="element-41" data-mp="2kaj2ovuf7kvs">
        <SectionHeading title="This Isn't Another Astrology Textbook." data-id="element-42" data-mp="2k9hj22zc9q2g" />
        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-43" data-mp="2obl51ljmwd1z">
          {differences.map((item, index) => {
          const Icon = icons[index];
          return <article key={item.title} className="flex flex-col rounded-2xl bg-brand-mist p-6" data-id="element-44" data-mp="2yaaaufy9a71v" data-mpi={index}>
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-violet text-white" data-id="element-45" data-mp="yx6aulpujxz3">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-46" data-mp="13vr94fljg7kw" />
                </span>
                <h3 className="mt-5 text-sm font-black uppercase tracking-[0.1em] text-brand-ink" data-id="element-47" data-mp="39ojdhalj14hf">{item.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-brand-ink/70" data-id="element-48" data-mp="34xkug395lsah">{item.description}</p>
              </article>;
        })}
        </div>
      </div>
    </section>;
}